import { initLiveList } from '../../shared/liveList.js';

// The log of the hourly Salesforce syncs (N15).
//
// Nothing but the live list. The page is deliberately read-only: pausing,
// resuming and releasing a blocked batch of deletions are CLI commands, so
// there is no action here to wire up and no polling either - a run is written
// to the log only once it is over, so a row on the page is always a finished
// run.
//
// Goes when Salesforce is retired, along with the rest of the module.

export function initSalesforceStatus() {
  initLiveList({
    results: 'salesforce-lauf-list',
    path: '/salesforce/status',
    forms: ['salesforce-lauf-filter']
  });
}
